import { FloatingAlertStore } from 'foundations-components/transitional/components/FloatingAlertList';
import { getEditorRoute } from '../utils/urls';
//@ts-expect-error no types for ui-addon-iframeable
import ModalIFrame from 'ui-addon-iframeable/host/ModalIFrame';
import { useCallback } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export let MessageTypes;
(function (MessageTypes) {
  MessageTypes["MSG_TYPE_FLOW_START"] = "FLOW_START";
  MessageTypes["MSG_TYPE_HIDE_MODAL"] = "HIDE_MODAL";
  MessageTypes["MSG_TYPE_MODAL_HIDDEN"] = "MODAL_HIDDEN";
  MessageTypes["MSG_TYPE_ADD_ALERT"] = "ADD_ALERT";
  MessageTypes["MSG_TYPE_APP_READY"] = "MSG_TYPE_APP_READY";
})(MessageTypes || (MessageTypes = {}));
export const CreditMemosEditorIframeModal = ({
  show,
  objectId,
  onClose,
  onError,
  operation
}) => {
  const src = getEditorRoute(operation, objectId);
  const handleCloseModal = useCallback(updatedCreditMemo => {
    window.onpopstate = null;
    if (onClose) {
      onClose(updatedCreditMemo);
    }
  }, [onClose]);
  const handleMessage = useCallback(message => {
    const {
      payload: {
        type
      }
    } = message;
    if (type === MessageTypes.MSG_TYPE_HIDE_MODAL) {
      handleCloseModal(message.payload.creditMemo);
    }
    if (type === MessageTypes.MSG_TYPE_ADD_ALERT) {
      FloatingAlertStore.addAlert(message.payload.alertProps);
    }
  }, [handleCloseModal]);
  const handleOnReady = useCallback(hostContext => {
    hostContext.sendMessage(MessageTypes.MSG_TYPE_APP_READY);
  }, []);
  const handleError = useCallback(error => {
    console.error(error);
    handleCloseModal();
    if (onError) {
      onError(error);
    }
  }, [handleCloseModal, onError]);
  return show && src ? /*#__PURE__*/_jsx(ModalIFrame, {
    appName: "credit-memos-editor-ui",
    iframePassthruProps: {
      'data-test-id': `credit-memo-editor-iframe-${show ? 'open' : 'closed'}`,
      id: 'credit-memo-editor-iframe',
      title: 'Credit Memo Editor'
    },
    embeddedPassthruProps: {},
    initTimeout: 60000,
    use: "fullscreen",
    width: "100%",
    height: "100%",
    src: src,
    showLoadingIndicator: true,
    onInitError: handleError,
    onReady: handleOnReady,
    onReadyError: handleError,
    onMessage: handleMessage,
    onClose: handleCloseModal
  }) : null;
};